import { render } from "./TraderList.vue?vue&type=template&id=429240ac"
import script from "./TraderList.vue?vue&type=script&lang=js"
export * from "./TraderList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__